import type { ShadowingState } from './types';

export function createInitialState(videoId: string | null = null): ShadowingState {
  return {
    videoId,
    currentCueIndex: null,
    segmentStartCueIndex: null,
    segmentEndCueIndex: null,
    isPlayingSegment: false,
    autoPauseTarget: null,
  };
}

export function assertStateInvariants(state: ShadowingState, cueCount: number): void {
  const { currentCueIndex, segmentStartCueIndex: start, segmentEndCueIndex: end } = state;
  if (start === null || end === null || currentCueIndex === null) {
    if (!(start === null && end === null && currentCueIndex === null)) {
      throw new Error('Cue selection must be entirely set or entirely empty');
    }
    return;
  }
  if (start < 0 || start > end || end >= cueCount || currentCueIndex !== start) {
    throw new Error('Invalid shadowing state');
  }
}
